import { DeltaServerChangeFeed } from "@hds-products/delta-server-client";
import { EventActivityClientEntity } from "../index.mjs";

class EventActivityClientChangeFeed extends DeltaServerChangeFeed {
    static DEFAULT_PROJECTION = { type: 'exclude', excludeProperties: ['processedEntries'] };
    constructor(deltaServerClient, baseUri, customHeaderFn, projection = EventActivityClientChangeFeed.DEFAULT_PROJECTION) {
        super(EventActivityClientEntity, deltaServerClient, baseUri, EventActivityClientEntity.prototype._meta.entityName, customHeaderFn, projection);
    }
}
export { EventActivityClientChangeFeed };
export default EventActivityClientChangeFeed;